"use strict";
/* tslint:disable:no-object-literal-type-assertion */
Object.defineProperty(exports, "__esModule", { value: true });
exports.CONFIGURATION_KEYS = void 0;
const configuration_1 = require("../configuration");
exports.CONFIGURATION_KEYS = {
    obstacles: {
        excludedRules: {
            name: `retroReport.obstacles.excludedRules`,
            chain: [configuration_1.ConfigurationEntityType.Team],
            type: {}
        }
    },
    highlights: {
        excludedRules: {
            name: `retroReport.highlights.excludedRules`,
            chain: [configuration_1.ConfigurationEntityType.Team],
            type: {}
        }
    },
    sprints: {
        unplannedTasksGraceHours: {
            name: `retroReport.sprints.unplannedTasksGraceHours`,
            chain: [configuration_1.ConfigurationEntityType.Team],
            type: {}
        }
    },
    logic: {
        subtaskSprintStrategy: {
            name: `retroReport.logic.subtaskSprintStrategy`,
            chain: [configuration_1.ConfigurationEntityType.Team],
            type: {}
        }
    }
};
//# sourceMappingURL=retro-report.js.map